import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await login(email, password); nav("/admin"); }
    catch (e2) { setErr(errMsg(e2)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0F19] grid-bg grid place-items-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-[#111827] border border-white/10 p-8 rise" data-testid="admin-login-form">
        <span className="w-11 h-11 rounded-xl bg-violet-600 grid place-items-center"><Lock className="w-5 h-5 text-white" /></span>
        <h1 className="font-heading font-extrabold text-3xl tracking-tight mt-5 text-white">Painel da loja</h1>
        <p className="text-sm text-slate-400 mt-1">Acesso restrito ao administrador.</p>
        <div className="space-y-4 mt-7">
          <div className="space-y-2"><Label className="text-slate-300">E-mail</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 bg-white/5 text-white" data-testid="admin-login-email-input" /></div>
          <div className="space-y-2"><Label className="text-slate-300">Senha</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 bg-white/5 text-white" data-testid="admin-login-password-input" /></div>
          {err && <p className="text-sm text-rose-400" data-testid="admin-login-error">{err}</p>}
          <button disabled={busy} className="w-full h-11 rounded-full bg-violet-600 hover:bg-violet-500 text-white font-semibold disabled:opacity-50" data-testid="admin-login-submit-button">
            {busy ? "Entrando..." : "Entrar"}
          </button>
        </div>
        <Link to="/" className="block text-center text-xs text-slate-500 hover:text-slate-300 mt-6" data-testid="admin-login-back-link">Voltar para a loja</Link>
      </form>
    </div>
  );
}
